import { FunctionComponent } from "react";
import { selectPictureById } from "../../selectors/pictures.js";
import { useAppSelector } from "../../store/hooks.js";
import {
  ColorScheme,
  ImageModuleSettings,
  TranslatedModule,
} from "../../types/index.js";
import { getRecursiveOverlayModule } from "../../utils/utils.js";
import CroppedImage from "../CroppedImage.js";
import OverlayModule from "./OverlayModule.js";

interface Props {
  aspectRatio: number | undefined;
  portraitAspectRatio?: number | undefined;
  width: number;
  lazyLoad?: boolean;
  sizes: string;
  translatedModule: TranslatedModule<ImageModuleSettings>;
  scheme: ColorScheme;
  pageId: string;
  isSlider: boolean;
  isPreview: boolean;
  showOverlay: boolean;
}

const ImageModule: FunctionComponent<Props> = ({
  aspectRatio,
  portraitAspectRatio,
  width,
  translatedModule: {
    settings: { pictureId },
    settings,
    translation: { languageId },
    id,
  },
  sizes,
  lazyLoad = true,
  scheme,
  pageId,
  isSlider,
  isPreview,
  showOverlay,
}) => {
  const modules = useAppSelector((state) => state.modules);

  const overlayModule = getRecursiveOverlayModule({
    languageId,
    modules,
    pageId,
    parentId: id,
  });

  const picture = useAppSelector((state) =>
    selectPictureById(state, pictureId),
  );

  return (
    <>
      <CroppedImage
        picture={picture}
        aspectRatio={aspectRatio}
        portraitAspectRatio={portraitAspectRatio}
        sizes={sizes}
        lazyLoad={lazyLoad}
        width={width}
        detail={settings}
      />
      {showOverlay && overlayModule && (
        <OverlayModule
          isPreview={isPreview}
          isSlider={isSlider}
          translatedModule={overlayModule}
          pageId={pageId}
          scheme={scheme}
        />
      )}
    </>
  );
};

export default ImageModule;
